/* ===========================================================================
   WARA measurements form.

   Holds NO storage knowledge — every read and write goes through
   window.WARAStore.measurements (assets/wara-account-store.js), which Session C
   swaps for customer metafields. Do not read localStorage here.

   Stored shape (v1), flat on purpose so Session C can map it 1:1 onto
   customer metafields:

     { v: 1, unit: "in",
       chest: 36, waist: 29, length: 25, inseam: 30,   // any may be null
       updated_at: "2026-08-12T09:00:00.000Z" }

   SEMANTICS, and the reason the labels are worded the way they are:
     chest / waist  are BODY circumference — how a shopper actually knows their size.
     length / inseam are PREFERRED GARMENT lengths — that is how the product
                     metafields measure them.
   The my-size filter converts: wara.chest_in is FLAT pit-to-pit, so garment
   circumference is 2x it. Anything comparing a body number to chest_in directly
   is wrong by a factor of two.

   Markup lives in Liquid (so it exists without JS); this only wires load, snap,
   validate and save. Fields opt in with data-wara-measure="<key>" and carry their
   own min/max.
   =========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-wara-measure]';

  function store() { return window.WARAStore; }
  function form() { return document.querySelector('[data-wara-measurements-form]'); }

  function fields(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(SEL));
  }

  function fieldError(el, msg) {
    var wrap = el.closest('.wmw-field');
    var slot = wrap && wrap.querySelector('[data-wara-measure-error]');
    if (slot) slot.textContent = msg || '';
    if (wrap) wrap.classList.toggle('has-error', !!msg);
    el.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  /* Empty is always valid — every field is optional. Values snap to 0.5 because
     that is the step the garment measurements are recorded at; accepting 36.3
     would imply precision the matching rule does not have. */
  function clean(el) {
    var raw = (el.value || '').trim();
    if (raw === '') return { ok: true, value: null };

    var n = Number(raw);
    if (!isFinite(n)) return { ok: false, msg: 'Numbers only' };

    var min = Number(el.getAttribute('min'));
    var max = Number(el.getAttribute('max'));
    if (isFinite(min) && n < min) return { ok: false, msg: 'Should be at least ' + min + '"' };
    if (isFinite(max) && n > max) return { ok: false, msg: 'Should be at most ' + max + '"' };

    return { ok: true, value: Math.round(n * 2) / 2 };
  }

  function load() {
    var s = store();
    if (!s) return;
    var m = s.measurements.getSync() || {};
    fields().forEach(function (el) {
      var v = m[el.getAttribute('data-wara-measure')];
      el.value = (v === 0 || v) ? String(v) : '';
      fieldError(el, '');
    });
  }

  function flash(msg) {
    var note = document.querySelector('[data-wara-measure-saved]');
    if (!note) return;
    note.textContent = msg;
    note.classList.add('is-shown');
    window.clearTimeout(note._waraTimer);
    note._waraTimer = window.setTimeout(function () {
      note.classList.remove('is-shown');
    }, 2600);
  }

  /* ?return= from the my-size control on a collection. Same-origin paths only —
     anything else (absolute URLs, //host, /\host) is ignored, never followed. */
  function returnPath() {
    var r = new URLSearchParams(location.search).get('return');
    if (!r || r.charAt(0) !== '/' || r.charAt(1) === '/' || r.charAt(1) === '\\') return null;
    try {
      var u = new URL(r, location.origin);
      return u.origin === location.origin ? u.pathname + u.search : null;
    } catch (err) { return null; }
  }

  function save(e) {
    if (e) e.preventDefault();
    var s = store();
    if (!s) return;

    var out = { v: 1, unit: 'in' };
    var bad = null;

    fields().forEach(function (el) {
      var r = clean(el);
      if (!r.ok) {
        fieldError(el, r.msg);
        if (!bad) bad = el;
        return;
      }
      fieldError(el, '');
      out[el.getAttribute('data-wara-measure')] = r.value;
    });

    if (bad) { bad.focus(); return; }

    out.updated_at = new Date().toISOString();

    Promise.resolve(s.measurements.set(out)).then(function () {
      // Snap the displayed values to what was actually stored (36.3 -> 36.5).
      fields().forEach(function (el) {
        var v = out[el.getAttribute('data-wara-measure')];
        el.value = (v === 0 || v) ? String(v) : '';
      });
      var any = ['chest', 'waist', 'length', 'inseam'].some(function (k) {
        return out[k] !== null && out[k] !== undefined;
      });
      flash(any ? 'Saved' : 'Cleared');
      // Back to the collection with My size switched on (the filter bar reads #my-size).
      var back = returnPath();
      if (back) location.assign(back + '#my-size');
    }).catch(function (err) {
      console.error('[wara-measurements] save failed', err);
      flash('Could not save on this device');
    });
  }

  function init() {
    var f = form();
    if (!f) return;
    load();
    f.addEventListener('submit', save);
    // Clear a field's error as soon as the shopper starts fixing it.
    f.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches(SEL)) fieldError(e.target, '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
